/* Package imports */

/* Component imports */
import { AllRoutes } from './index';

const Routes = () => {
    return (
            <AllRoutes />
    );
};

export default Routes;
